/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogModel
 */
export interface LogModel {
    /**
     * 
     * @type {number}
     * @memberof LogModel
     */
    durationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof LogModel
     */
    exceptionClass?: string;
    /**
     * 
     * @type {string}
     * @memberof LogModel
     */
    exceptionMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof LogModel
     */
    exceptionStackTrace?: string;
    /**
     * 
     * @type {number}
     * @memberof LogModel
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LogModel
     */
    succeeded?: boolean;
    /**
     * 
     * @type {any}
     * @memberof LogModel
     */
    taskData?: any | null;
    /**
     * 
     * @type {string}
     * @memberof LogModel
     */
    taskInstance?: string;
    /**
     * 
     * @type {string}
     * @memberof LogModel
     */
    taskName?: string;
    /**
     * 
     * @type {Date}
     * @memberof LogModel
     */
    timeFinished?: Date;
    /**
     * 
     * @type {Date}
     * @memberof LogModel
     */
    timeStarted?: Date;
}

/**
 * Check if a given object implements the LogModel interface.
 */
export function instanceOfLogModel(value: object): value is LogModel {
    return true;
}

export function LogModelFromJSON(json: any): LogModel {
    return LogModelFromJSONTyped(json, false);
}

export function LogModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogModel {
    if (json == null) {
        return json;
    }
    return {
        
        'durationMs': json['durationMs'] == null ? undefined : json['durationMs'],
        'exceptionClass': json['exceptionClass'] == null ? undefined : json['exceptionClass'],
        'exceptionMessage': json['exceptionMessage'] == null ? undefined : json['exceptionMessage'],
        'exceptionStackTrace': json['exceptionStackTrace'] == null ? undefined : json['exceptionStackTrace'],
        'id': json['id'] == null ? undefined : json['id'],
        'succeeded': json['succeeded'] == null ? undefined : json['succeeded'],
        'taskData': json['taskData'] === undefined ? undefined : json['taskData'] === null ? null : json['taskData'],
        'taskInstance': json['taskInstance'] == null ? undefined : json['taskInstance'],
        'taskName': json['taskName'] == null ? undefined : json['taskName'],
        'timeFinished': json['timeFinished'] == null ? undefined : (new Date(json['timeFinished'])),
        'timeStarted': json['timeStarted'] == null ? undefined : (new Date(json['timeStarted'])),
    };
}

export function LogModelToJSON(json: any): LogModel {
    return LogModelToJSONTyped(json, false);
}

export function LogModelToJSONTyped(value?: LogModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'durationMs': value['durationMs'],
        'exceptionClass': value['exceptionClass'],
        'exceptionMessage': value['exceptionMessage'],
        'exceptionStackTrace': value['exceptionStackTrace'],
        'id': value['id'],
        'succeeded': value['succeeded'],
        'taskData': value['taskData'],
        'taskInstance': value['taskInstance'],
        'taskName': value['taskName'],
        'timeFinished': value['timeFinished'] == null ? value['timeFinished'] : value['timeFinished'].toISOString(),
        'timeStarted': value['timeStarted'] == null ? value['timeStarted'] : value['timeStarted'].toISOString(),
    };
}

